import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'leaflet/dist/leaflet.css';
import '@/styles/global.css';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
